import '../../styles/AthleteCard.css';

import React, { useState } from 'react';

import {
  Card,
  Typography,
} from './index';

interface AthleteCardProps {
  id: string;
  name: string;
  number: string;
  position: string;
  returningstatus?: string;
  coach: string;
  teamplacement?: string;
  imageUrl?: string;
  onClick: (id: string) => void;
}

export default function AthleteCard({
  id,
  name,
  number,
  position,
  returningstatus,
  coach,
  teamplacement,
  imageUrl,
  onClick
}: AthleteCardProps) {
  const [imageLoaded, setImageLoaded] = useState(false);

  const teamplacementInfo = (() => {
    if (teamplacement === 'coed') {
      return {
        label: 'COED',
        color: 'green',
      };
    } else if (teamplacement === 'allgirl') {
      return {
        label: 'ALLGIRL',
        color: 'green',
      };
    } else if (teamplacement === 'level4') {
      return {
        label: 'LVL4',
        color: 'green',
      };
    } else if (teamplacement === 'yes') {
      return {
        label: 'Yes?',
        color: 'orange',
      };
    } else if (teamplacement === 'maybe') {
      return {
        label: 'Maybe',
        color: 'purple',
      };
    } else if (teamplacement === 'no') {
      return {
        label: 'No',
        color: 'red',
      };
    }
    return {
      label: '',
      color: 'transparent',
    };
  })();
  
  return (
    <Card 
      className="athlete-card"
      onClick={() => onClick(id)}
    >
      <div className="athlete-image">
        {imageUrl ? (
          <img 
            src={imageUrl} 
            alt={name} 
            onLoad={() => setImageLoaded(true)}
            style={{
              opacity: imageLoaded ? 1 : 0,
              transition: 'opacity 0.4s ease'
            }}
            loading="lazy"
          />
        ) : (
          <div className="placeholder-image">
            <span>{name.charAt(0)}</span>
          </div>
        )}
      </div>
      <div className="athlete-card-rightside"> 
        <div className="athlete-info">
          <Typography variant="h3">{name}</Typography>
          <Typography variant="body">#{number}</Typography>
          <div className="athlete-card-pills">
            {returningstatus != null &&
              <Typography variant="body" className="position-tag">
                {returningstatus}
              </Typography>
            }
            <Typography variant="body" className="position-tag">
              {position}
            </Typography>
          </div>
          <Typography variant="body" className="coach-name">
            Coach: {coach}
          </Typography>
        </div>
        <div className="team-placement" style={{ backgroundColor: teamplacementInfo.color }}>
          <Typography align='center' variant="caption" color='white'>{teamplacementInfo.label}</Typography>
        </div>
      </div>
    </Card>
  );
} 